import React, { Component } from 'react';
import { Form, FormControl, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { 
  getChartInfo, 
  getTickerSearchInfo,
  getTickerNewsInfo 
} from '../../../actions';
import TickerModal from '../../TickerModal/TickerModal';

class TickerSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      symbol: '',
      showTickerModal: false
    };
  }

  openModal = () => { 
    const { symbol } = this.state;
    this.props.getChartInfo({ symbol, range: '1m' });
    this.props.getTickerSearchInfo({ symbol });
    this.props.getTickerNewsInfo({ symbol });
    this.setState({ showTickerModal: true }); 
  }

  closeModal = () => { 
    this.setState({ showTickerModal: false, symbol: '' }); 
  }

  onSearch = (e) => {
    e.preventDefault();
    this.openModal();
  }

  render() {
    return (
      <div>
        <TickerModal 
          showTickerModal={this.state.showTickerModal} 
          closeModal={this.closeModal} 
          currentTickerInfo={this.props.user.tickerSearchInfo} 
          getChartInfo={this.props.getChartInfo} 
          chartInfo={this.props.user.chartInfo} 
          tickerNewsInfo={this.props.user.tickerNewsInfo} />

        <Form onSubmit={(e) => this.onSearch(e)}>
          <FormControl 
            required
            type="text" 
            value={this.state.symbol}
            onChange={(e) => this.setState({ symbol: e.target.value })}
            placeholder="Search ticker" />
          <Button
            style={{ marginRight: 0 }}
            bsStyle="primary" 
            type="submit"
          >Search</Button>
        </Form> 
      </div>
    );
  }
}

function mapStateToProps ({ user }) {
  return {
    user
  }
}

export default connect(mapStateToProps, { 
  getChartInfo, 
  getTickerSearchInfo, 
  getTickerNewsInfo 
})(TickerSearch);